import { marketBackend, marketRequest } from './marketRefresh'
import { stockQuoteKey } from './stockQuoteFeed'

export async function requestUS(kind, params = {}) {
  return marketRequest(kind, params)
}

export function normalizeUSQuote(data) {
  if (!Array.isArray(data) || data.length < 52 || !(Number(data[3]) > 0) || !Number.isFinite(Number(data[3]))) throw new Error('美股行情格式异常')
  // H5 gMZixuanJiaoyi.vue, mk=3; US PE/PB/turnover differ from Hong Kong.
  return { name: data[1], price: data[3], change: data[32], high: data[33], low: data[34], open: data[5], close: data[4], volume: data[36], amount: data[37], amplitude: data[43], marketValue: data[45], floatValue: data[44], pe: data[39], pb: data[51], turnover: data[38] }
}

// H5 hotGGpage: plate=601 returns the full US industry list, not overview highlights.
export async function getUSIndustries(initial = false) {
  const rows = await marketBackend('stockGGHot', { plate: 601, rank: 1, include_quote: 1 }, 'post')
  if (!Array.isArray(rows)) throw new Error('美股行业返回异常')
  return rows.map(item => ({ bd_code: item.code, bd_name: item.prod_name, bd_zdf: item.px_change_rate, nzg_name: item.fn || '', nzg_zxj: item.nzg_zxj, nzg_zdf: item.fzdf, code: item.fc ? stockQuoteKey(item.fc, 'us') : '' }))
}

export async function getUSConstituents(index, page = 1) {
  const result = await marketRequest('us-constituents', { index, page }, true)
  if (!result || result.code !== 0 || !Array.isArray(result.data && result.data.rank_list) || !Number.isFinite(Number(result.data.total))) throw new Error('美股成分股返回异常')
  return { total: Number(result.data.total), stocks: result.data.rank_list.map(item => ({ ...item, full_code: item.code.replace(/\.(N|OQ|AM)$/i, ''), prod_name: item.name, last_px: item.zxj, px_change_rate: item.zdf })) }
}

export async function getUSOverview() {
  const value = await marketBackend('stockMGRank')
  if (!value || !Array.isArray(value.index)) throw new Error('美股行情返回异常')
  return { indexes: value.index, industries: value.industry || [], ranks: { 'china-advance': value.advance1 || [], 'tech-advance': value.advance2 || [] } }
}

export function usOrderError({ side, tradeType, contractId, code, quantity, price, priceType, sellable }) {
  if (!['buy', 'sell'].includes(side) || ![1, 2].includes(tradeType) || ![0, 1].includes(priceType)) return '请选择有效的交易操作及委托类型'
  if (!contractId) return '请选择美股合约'
  if (!/^us[A-Za-z0-9][A-Za-z0-9._-]{0,39}$/.test(code || '')) return '无效的美股代码'
  if (!Number.isSafeInteger(Number(quantity)) || Number(quantity) <= 0) return '请输入正整数股数'
  if (side === 'buy' && Number(quantity) % 100 !== 0) return '当前系统开仓数量须为100股整数倍'
  if (side === 'sell' && (!Number.isFinite(sellable) || Number(quantity) > sellable)) return '平仓数量超过当前方向持仓股数'
  if (priceType === 0 && (!Number.isFinite(Number(price)) || Number(price) <= 0)) return '请输入有效的限价'
  return ''
}
